/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Add_TeamInputs */

const th_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มทีม`)
};

const en_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a team`)
};

const ja_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームを追加`)
};

const zh_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加球队`)
};

const es_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir un equipo`)
};

const pt_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar um time`)
};

const id_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah tim`)
};

const fr_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une équipe`)
};

const tl_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magdagdag ng team`)
};

const vi_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm đội`)
};

const ko_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀 추가`)
};

const de_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team hinzufügen`)
};

const ru_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить команду`)
};

const tr_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takım ekle`)
};

const it_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi squadra`)
};

const pl_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj drużynę`)
};

const uk_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додати команду`)
};

const hi_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम जोड़ें`)
};

const ar_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة فريق`)
};

const ms_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah pasukan`)
};

const bn_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল যোগ করুন`)
};

const zh_tw2_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增球隊`)
};

const zh_hk2_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增球隊`)
};

const ur_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیم شامل کریں`)
};

const fa_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افزودن تیم`)
};

const sw_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeza timu`)
};

const nl_org_add_team = /** @type {(inputs: Org_Add_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team toevoegen`)
};

/**
* | output |
* | --- |
* | "Add a team" |
*
* @param {Org_Add_TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_add_team = /** @type {((inputs?: Org_Add_TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Add_TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_add_team(inputs)
	if (locale === "ja") return ja_org_add_team(inputs)
	if (locale === "zh") return zh_org_add_team(inputs)
	if (locale === "es") return es_org_add_team(inputs)
	if (locale === "pt") return pt_org_add_team(inputs)
	if (locale === "id") return id_org_add_team(inputs)
	if (locale === "fr") return fr_org_add_team(inputs)
	if (locale === "tl") return tl_org_add_team(inputs)
	if (locale === "vi") return vi_org_add_team(inputs)
	if (locale === "ko") return ko_org_add_team(inputs)
	if (locale === "de") return de_org_add_team(inputs)
	if (locale === "ru") return ru_org_add_team(inputs)
	if (locale === "tr") return tr_org_add_team(inputs)
	if (locale === "it") return it_org_add_team(inputs)
	if (locale === "pl") return pl_org_add_team(inputs)
	if (locale === "uk") return uk_org_add_team(inputs)
	if (locale === "hi") return hi_org_add_team(inputs)
	if (locale === "ar") return ar_org_add_team(inputs)
	if (locale === "ms") return ms_org_add_team(inputs)
	if (locale === "bn") return bn_org_add_team(inputs)
	if (locale === "zh-TW") return zh_tw2_org_add_team(inputs)
	if (locale === "zh-HK") return zh_hk2_org_add_team(inputs)
	if (locale === "ur") return ur_org_add_team(inputs)
	if (locale === "fa") return fa_org_add_team(inputs)
	if (locale === "sw") return sw_org_add_team(inputs)
	if (locale === "nl") return nl_org_add_team(inputs)
	return en_org_add_team(inputs)
});